import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonLoading } from 'src/app/models/button-loading.model';

@Component({
  selector: 'app-loading-button',
  templateUrl: './loading-button.component.html',
  styleUrls: ['./loading-button.component.scss']
})
export class LoadingButtonComponent {
  @Input() object: ButtonLoading = new ButtonLoading("btn-success", false, "GUARDAR", "fa-save");
  @Input() disabled: boolean = false;
  @Input() changingMessage: { new: string } = null;
  @Input() button: boolean = true;
  @Input() logo: boolean = false;
  @Input() colorLoading: string = "#001f54";
  @Input() heightLogo: string = "1.4rem";
  @Output() clicked = new EventEmitter();
}
